import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.411 7H16v2H4.417l4.33 4.33-1.414 1.415-6.04-6.04a1 1 0 0 1 0-1.415l6.04-6.04 1.415 1.414L4.41 7z",
		fill: "currentColor"
	})
});
export default SvgArrowLeftinline;
